import { Injectable } from '@angular/core';
import { Domain } from '@engagement/core/store/domain/domain.model';

import * as DomainAction from './domain.action';

export { DomainAction };

@Injectable({
  providedIn: 'root',
})
export class DomainDispatcher {
  public load() {
    return DomainAction.Load();
  }
  public loadFail(error: string) {
    return DomainAction.LoadFail({ error });
  }
  public loadSuccess(domain: Domain) {
    return DomainAction.LoadSuccess({ domain });
  }
  public change(domain: Domain) {
    return DomainAction.Change({ domain: domain });
  }
}
